/**
 * Turn End Screen — Summary of the turn + protest option.
 */

import { getState, getNextCardReader, skipProtests, startProtestResolution, getTurnRoster } from '../game-state';
import { navigate } from '../router';
import { t } from '../i18n';

export function renderTurnEnd(): void {
  const app = document.getElementById('app')!;
  const state = getState();
  const summary = state.lastTurnSummary;

  if (!summary) {
    navigate('turn-waiting');
    return;
  }

  const nextReader = getNextCardReader();
  const hasProtestableCards = summary.protests.length > 0;

  app.innerHTML = `
    <div class="stack">
      <h1 style="font-size: var(--font-size-xl);">${t('timesUp')}</h1>

      <div class="surface">
        <h3>${summary.cardReaderName} (${t('team', summary.team)})</h3>

        <div class="stack-sm" style="margin-top: var(--space-md);">
          <div class="turn-summary-stat">
            <span>${t('cardsCorrect')}</span>
            <span class="stat-value">${summary.cardsCorrect}</span>
          </div>
          <div class="turn-summary-stat">
            <span>${t('pointsEarned')}</span>
            <span class="stat-value" style="color: var(--color-success);">+${summary.pointsEarned}</span>
          </div>
          ${summary.cardsSkipped > 0 ? `
            <div class="turn-summary-stat">
              <span>${t('cardsSkipped')}</span>
              <span class="stat-value">${summary.cardsSkipped}</span>
            </div>
            <div class="turn-summary-stat">
              <span>${t('pointsLost')}</span>
              <span class="stat-value" style="color: var(--color-danger);">-${summary.pointsLost}</span>
            </div>
          ` : ''}
        </div>
      </div>

      <!-- Score Bar -->
      <div class="score-bar">
        <div>
          <span class="team-label">${t('teamA')}</span>
          <span class="team-score">&nbsp;${state.scores.A}</span>
        </div>
        <div>
          <span class="team-score">${state.scores.B}&nbsp;</span>
          <span class="team-label">${t('teamB')}</span>
        </div>
      </div>

      <!-- Turn Order Roster -->
      <div class="surface" style="padding: var(--space-sm) var(--space-md);">
        <div class="row" style="justify-content: space-between; font-size: var(--font-size-xs);">
          <div>
            <span class="text-muted">${t('teamA')}: </span>
            ${getTurnRoster('A').map((e) =>
              e.status === 'done' ? `<span style="color: var(--color-success);">✓${e.player.displayName}</span>`
              : e.status === 'current' ? `<span style="color: var(--color-accent);">→${e.player.displayName}</span>`
              : `<span class="text-muted">${e.player.displayName}</span>`
            ).join(' ')}
          </div>
          <div>
            <span class="text-muted">${t('teamB')}: </span>
            ${getTurnRoster('B').map((e) =>
              e.status === 'done' ? `<span style="color: var(--color-success);">✓${e.player.displayName}</span>`
              : e.status === 'current' ? `<span style="color: var(--color-accent);">→${e.player.displayName}</span>`
              : `<span class="text-muted">${e.player.displayName}</span>`
            ).join(' ')}
          </div>
        </div>
      </div>

      <!-- Protest option -->
      ${hasProtestableCards ? `
        <button class="btn btn-secondary" id="btn-protest"
          style="border-color: var(--color-warning); color: var(--color-warning);">
          ${t('protestACard')}
        </button>
      ` : ''}

      <!-- Next turn -->
      <div class="surface center" style="padding: var(--space-md);">
        <p class="text-muted" style="font-size: var(--font-size-sm);">${t('nextUp')}</p>
        <p style="font-weight: var(--font-weight-bold); font-size: var(--font-size-lg); margin-top: var(--space-xs);">
          ${nextReader?.displayName || t('nextPlayer')}
        </p>
        <p class="text-muted" style="font-size: var(--font-size-sm);">
          ${t('team', state.currentTeam === 'A' ? 'B' : 'A')}
        </p>
      </div>

      <button class="btn btn-primary" id="btn-continue">${t('continue')}</button>
    </div>
  `;

  document.getElementById('btn-protest')?.addEventListener('click', () => {
    startProtestResolution();
    navigate('protest');
  });

  document.getElementById('btn-continue')?.addEventListener('click', () => {
    skipProtests();
    const s = getState();
    if (s.phase === 'round-complete') {
      navigate('round-complete');
    } else {
      navigate('turn-waiting');
    }
  });
}
